var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{attrs:{"label":_vm.optDesc.$attrs.title + ': ' + _vm.displayValue,"label-for":_vm.id,"disabled":_vm.disabled}},[_c('div',{staticClass:"z42opt-range",attrs:{"id":_vm.id,"disabled":_vm.disabled}})])}
var staticRenderFns = []

export { render, staticRenderFns }